import {
  DRAWER_INACTIVE_SELECTION,
  PRIMARY_BLUE,
  FITOGRAM_BLUE_TINTED,
  GRAY_DARK_USC,
  GRAY_USC,
  RED_USC,
} from '~/Constants/Colors.constants';
import {
  FONT_SIZE_INBETWEEN,
  FONT_SIZE_LARGE,
  FONT_SIZE_LARGISH,
  FONT_SIZE_MEDIUM_INBETWEEN,
} from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const ManageBookingsMenuStyles = makeStyles((theme) => ({
  iconColor: {
    fill: RED_USC,
  },
  note: {
    display: 'flex',
    columnGap: 8,
    margin: '24px 0',
    [theme.breakpoints.up('md')]: {
      margin: '16px 0',
    },
    '& > p': {
      fontWeight: 'bold',
    },
  },
  textWrapper: {
    borderBottom: `1px solid ${DRAWER_INACTIVE_SELECTION}`,
    '& *': {
      fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    },
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '16px 0',
  },
  firstRow: {
    margin: ' 24px 0',
  },
  normalText: {
    fontSize: FONT_SIZE_LARGISH,
    lineHeight: '28px',
    fontWeight: 'bold',
    [theme.breakpoints.up('md')]: {
      fontSize: FONT_SIZE_LARGE,
      letterSpacing: '-0.45px',
    },
  },
  eventWrapper: {
    display: 'flex',
    margin: '24px 0',
    columnGap: 16,
    [theme.breakpoints.up('md')]: {
      marginTop: 18,
      columnGap: 8,
    },
  },
  date: {
    fontSize: FONT_SIZE_LARGISH,
    lineHeight: '28px',
    fontWeight: 'bold',
    color: GRAY_USC,
    [theme.breakpoints.up('md')]: {
      fontSize: FONT_SIZE_LARGE,
    },
  },
  arrow: {
    cursor: 'pointer',
    fill: PRIMARY_BLUE,
  },
  disabled: {
    cursor: 'not-allowed',
    pointerEvents: 'none',
    fill: DRAWER_INACTIVE_SELECTION,
  },
  comboboxInput: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${GRAY_DARK_USC}`,
      borderRadius: 6,
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline ': {
      border: `2px solid ${FITOGRAM_BLUE_TINTED}`,
    },
  },
  label: {
    fontSize: FONT_SIZE_INBETWEEN,
    lineHeight: '20px',
    marginBottom: 8,
    letterSpacing: '-0.15px',
    fontWeight: 'bold',
    color: GRAY_USC,
  },
  membership: {
    padding: 14,
    borderRadius: 6,
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: FITOGRAM_BLUE_TINTED,
      },
    },
    '& > input': {
      padding: 0,
    },
  },
  listItem: {
    display: 'flex',
    gap: 16,
  },
  listLocation: {
    color: GRAY_USC,
    lineHeight: '22px',
  },
  listDate: {
    display: 'grid',
    '& *': {
      fontWeight: 'bold',
    },
  },
  name: {
    fontSize: FONT_SIZE_MEDIUM_INBETWEEN,
    lineHeight: '24px',
    fontWeight: 'bold',
  },
}));
